<template lang="pug">
  include ./../../mixins
  +b.bg--grey4.SECTION
    +b.ug-container--variant_large
      +b.router-tab
        +e.common-wrapper
          +e.element.ROUTER-LINK(
            v-if="item.roles.includes(userRole)"
            v-for="(item, index) in tabs"
            :key="item.id"
            :to="{ name: item.routs }"
            exact-active-class="router-tab__element--isactive"
          )
            +e.text {{ item.title }}
          +e.element--pointer.u-display--block.--hidden-lg(
            @click.prevent="postLogoutCabinetAPI"
          )
            +e.text Logout
        +e.action-wrapper.u-display--hidden.--block-lg
          +e.element--pointer(
            @click.prevent="postLogoutCabinetAPI"
          )
            +e.text Logout
</template>

<script>
import {
  postLogoutCabinetAPI,
} from '@/js/services/cabinet'

export default {
  name: 'RouterModule',
  data() {
    return {
      userRole: window.role,
      tabs: [
        {
          roles: ['administrator', 'user'],
          title: '7 Days Statistics',
          routs: 'StatisticsCabinet',
          id: 1,
        },
        {
          roles: ['administrator'],
          title: 'Order statistics',
          routs: 'StatisticsCoreCabinet',
          id: 2,
        },
        {
          roles: ['administrator', 'user'],
          title: 'Create order',
          routs: 'NewOrderCabinet',
          id: 3,
        },
        {
          roles: ['administrator', 'user'],
          title: 'Order History',
          routs: 'OrderHistoryCabinet',
          id: 4,
        },
        {
          roles: ['administrator', 'user'],
          title: 'Balance History',
          routs: 'BalanceHistoryCabinet',
          id: 5,
        },
        {
          roles: ['administrator', 'user'],
          title: 'Invoice History',
          routs: 'InvoiceHistoryCabinet',
          id: 6,
        },
        {
          roles: ['administrator', 'user'],
          title: 'Withdraw',
          routs: 'WithdrawCabinet',
          id: 7,
        },
        {
          roles: ['administrator', 'user'],
          title: 'Profile',
          routs: 'SettingsCabinet',
          id: 8,
        },
      ],
    }
  },
  methods: {
    postLogoutCabinetAPI() {
      return postLogoutCabinetAPI.execute({})
        .then(response => {
          window.location.href = '/'
        })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Modules/RouterModule.vue